

export const data = {
    "Meta Data": {
        "1. Information": "Intraday (5min) open, high, low, close prices and volume",
        "2. Symbol": "IBM",
        "3. Last Refreshed": "2024-04-19 19:55:00",
        "4. Interval": "5min",
        "5. Output Size": "Compact",
        "6. Time Zone": "US/Eastern"
    },
    "Time Series (5min)": {
        "2024-04-19 19:55:00": {
            "1. open": "181.5200",
            "2. high": "181.5800",
            "3. low": "181.4600",
            "4. close": "181.5100",
            "5. volume": "158"
        },
        "2024-04-19 19:40:00": {
            "1. open": "181.2000",
            "2. high": "181.2000",
            "3. low": "181.2000",
            "4. close": "181.2000",
            "5. volume": "27"
        },
        "2024-04-19 19:30:00": {
            "1. open": "181.5600",
            "2. high": "181.5600",
            "3. low": "181.5600",
            "4. close": "181.5600",
            "5. volume": "20"
        },
        "2024-04-19 19:25:00": {
            "1. open": "181.5600",
            "2. high": "181.5600",
            "3. low": "181.5600",
            "4. close": "181.5600",
            "5. volume": "1"
        },
        "2024-04-19 19:20:00": {
            "1. open": "181.5800",
            "2. high": "181.5800",
            "3. low": "181.2000",
            "4. close": "181.2000",
            "5. volume": "45"
        },
        "2024-04-19 19:00:00": {
            "1. open": "181.5800",
            "2. high": "181.5800",
            "3. low": "181.5700",
            "4. close": "181.5800",
            "5. volume": "495712"
        },
        "2024-04-19 18:55:00": {
            "1. open": "181.6000",
            "2. high": "181.6000",
            "3. low": "181.6000",
            "4. close": "181.6000",
            "5. volume": "2"
        },
        "2024-04-19 18:50:00": {
            "1. open": "181.5500",
            "2. high": "181.5500",
            "3. low": "181.5500",
            "4. close": "181.5500",
            "5. volume": "33"
        },
        "2024-04-19 18:40:00": {
            "1. open": "181.7500",
            "2. high": "181.7500",
            "3. low": "181.7500",
            "4. close": "181.7500",
            "5. volume": "22"
        },
        "2024-04-19 18:30:00": {
            "1. open": "181.5800",
            "2. high": "181.5800",
            "3. low": "181.5800",
            "4. close": "181.5800",
            "5. volume": "495658"
        },
        "2024-04-19 18:05:00": {
            "1. open": "181.6100",
            "2. high": "181.6100",
            "3. low": "181.6100",
            "4. close": "181.6100",
            "5. volume": "4"
        },
        "2024-04-19 17:55:00": {
            "1. open": "181.5810",
            "2. high": "181.7000",
            "3. low": "181.1850",
            "4. close": "181.7000",
            "5. volume": "40103"
        },
        "2024-04-19 17:45:00": {
            "1. open": "181.7500",
            "2. high": "181.7500",
            "3. low": "181.5800",
            "4. close": "181.5800",
            "5. volume": "25"
        },
        "2024-04-19 17:20:00": {
            "1. open": "181.6100",
            "2. high": "181.6100",
            "3. low": "181.6000",
            "4. close": "181.6000",
            "5. volume": "7"
        },
        "2024-04-19 17:15:00": {
            "1. open": "181.6100",
            "2. high": "181.6100",
            "3. low": "181.5800",
            "4. close": "181.5800",
            "5. volume": "4"
        },
        "2024-04-19 17:10:00": {
            "1. open": "181.6100",
            "2. high": "181.6100",
            "3. low": "181.5800",
            "4. close": "181.6100",
            "5. volume": "8"
        },
        "2024-04-19 17:05:00": {
            "1. open": "181.5900",
            "2. high": "181.7300",
            "3. low": "181.5900",
            "4. close": "181.7000",
            "5. volume": "40"
        },
        "2024-04-19 16:55:00": {
            "1. open": "181.5800",
            "2. high": "181.7500",
            "3. low": "181.3000",
            "4. close": "181.7500",
            "5. volume": "769"
        },
        "2024-04-19 16:50:00": {
            "1. open": "181.5900",
            "2. high": "181.5900",
            "3. low": "181.3000",
            "4. close": "181.3000",
            "5. volume": "12"
        },
        "2024-04-19 16:45:00": {
            "1. open": "181.6000",
            "2. high": "181.6200",
            "3. low": "181.6000",
            "4. close": "181.6000",
            "5. volume": "187"
        },
        "2024-04-19 16:40:00": {
            "1. open": "181.5900",
            "2. high": "181.7500",
            "3. low": "181.5900",
            "4. close": "181.7500",
            "5. volume": "104"
        },
        "2024-04-19 16:35:00": {
            "1. open": "181.7500",
            "2. high": "181.7500",
            "3. low": "181.6000",
            "4. close": "181.6100",
            "5. volume": "395"
        },
        "2024-04-19 16:30:00": {
            "1. open": "181.5000",
            "2. high": "181.9500",
            "3. low": "181.5000",
            "4. close": "181.9500",
            "5. volume": "244"
        },
        "2024-04-19 16:25:00": {
            "1. open": "181.5300",
            "2. high": "181.5300",
            "3. low": "181.0000",
            "4. close": "181.4500",
            "5. volume": "1057"
        },
        "2024-04-19 16:15:00": {
            "1. open": "181.5800",
            "2. high": "181.5800",
            "3. low": "180.5000",
            "4. close": "180.5000",
            "5. volume": "24"
        },
        "2024-04-19 16:10:00": {
            "1. open": "181.5800",
            "2. high": "181.6500",
            "3. low": "181.0300",
            "4. close": "181.0300",
            "5. volume": "495665"
        },
        "2024-04-19 16:05:00": {
            "1. open": "181.5800",
            "2. high": "181.5800",
            "3. low": "181.0300",
            "4. close": "181.5800",
            "5. volume": "3845"
        },
        "2024-04-19 16:00:00": {
            "1. open": "181.5900",
            "2. high": "181.6300",
            "3. low": "181.5800",
            "4. close": "181.5800",
            "5. volume": "1120380"
        },
        "2024-04-19 15:55:00": {
            "1. open": "181.2300",
            "2. high": "181.6600",
            "3. low": "181.1700",
            "4. close": "181.5900",
            "5. volume": "262914"
        },
        "2024-04-19 15:50:00": {
            "1. open": "180.6600",
            "2. high": "181.2300",
            "3. low": "180.6500",
            "4. close": "181.2300",
            "5. volume": "94608"
        },
        "2024-04-19 15:45:00": {
            "1. open": "180.8200",
            "2. high": "180.8200",
            "3. low": "180.5700",
            "4. close": "180.6800",
            "5. volume": "96146"
        },
        "2024-04-19 15:40:00": {
            "1. open": "180.9600",
            "2. high": "180.9700",
            "3. low": "180.6400",
            "4. close": "180.8300",
            "5. volume": "69614"
        },
        "2024-04-19 15:35:00": {
            "1. open": "181.1800",
            "2. high": "181.2400",
            "3. low": "180.8800",
            "4. close": "180.9800",
            "5. volume": "56716"
        },
        "2024-04-19 15:30:00": {
            "1. open": "181.3300",
            "2. high": "181.3500",
            "3. low": "181.1100",
            "4. close": "181.1800",
            "5. volume": "49520"
        },
        "2024-04-19 15:25:00": {
            "1. open": "181.2500",
            "2. high": "181.4850",
            "3. low": "181.1750",
            "4. close": "181.3300",
            "5. volume": "34657"
        },
        "2024-04-19 15:20:00": {
            "1. open": "181.3700",
            "2. high": "181.4400",
            "3. low": "181.2400",
            "4. close": "181.2400",
            "5. volume": "25271"
        },
        "2024-04-19 15:15:00": {
            "1. open": "181.3100",
            "2. high": "181.3200",
            "3. low": "181.1450",
            "4. close": "181.3100",
            "5. volume": "31183"
        },
        "2024-04-19 15:10:00": {
            "1. open": "181.2700",
            "2. high": "181.4300",
            "3. low": "181.2100",
            "4. close": "181.3300",
            "5. volume": "28436"
        },
        "2024-04-19 15:05:00": {
            "1. open": "181.2700",
            "2. high": "181.3500",
            "3. low": "181.1100",
            "4. close": "181.3100",
            "5. volume": "22895"
        },
        "2024-04-19 15:00:00": {
            "1. open": "181.3500",
            "2. high": "181.4150",
            "3. low": "181.2400",
            "4. close": "181.2900",
            "5. volume": "17124"
        },
        "2024-04-19 14:55:00": {
            "1. open": "181.2000",
            "2. high": "181.4900",
            "3. low": "181.1800",
            "4. close": "181.3850",
            "5. volume": "27803"
        },
        "2024-04-19 14:50:00": {
            "1. open": "181.2900",
            "2. high": "181.4100",
            "3. low": "181.1200",
            "4. close": "181.2300",
            "5. volume": "23473"
        },
        "2024-04-19 14:45:00": {
            "1. open": "181.2000",
            "2. high": "181.3000",
            "3. low": "181.1300",
            "4. close": "181.2900",
            "5. volume": "28962"
        },
        "2024-04-19 14:40:00": {
            "1. open": "181.3500",
            "2. high": "181.3900",
            "3. low": "181.2300",
            "4. close": "181.2300",
            "5. volume": "32312"
        },
        "2024-04-19 14:35:00": {
            "1. open": "181.5700",
            "2. high": "181.6250",
            "3. low": "181.3200",
            "4. close": "181.3800",
            "5. volume": "23125"
        },
        "2024-04-19 14:30:00": {
            "1. open": "181.6500",
            "2. high": "181.7900",
            "3. low": "181.5400",
            "4. close": "181.5900",
            "5. volume": "15863"
        },
        "2024-04-19 14:25:00": {
            "1. open": "181.8300",
            "2. high": "181.8700",
            "3. low": "181.6000",
            "4. close": "181.6100",
            "5. volume": "19472"
        },
        "2024-04-19 14:20:00": {
            "1. open": "181.8800",
            "2. high": "181.9500",
            "3. low": "181.7800",
            "4. close": "181.8700",
            "5. volume": "17958"
        },
        "2024-04-19 14:15:00": {
            "1. open": "181.7700",
            "2. high": "181.9200",
            "3. low": "181.6600",
            "4. close": "181.9200",
            "5. volume": "12618"
        },
        "2024-04-19 14:10:00": {
            "1. open": "181.9400",
            "2. high": "181.9600",
            "3. low": "181.7400",
            "4. close": "181.7500",
            "5. volume": "11829"
        },
        "2024-04-19 14:05:00": {
            "1. open": "181.7400",
            "2. high": "182.0900",
            "3. low": "181.6700",
            "4. close": "181.8900",
            "5. volume": "22141"
        },
        "2024-04-19 14:00:00": {
            "1. open": "181.9000",
            "2. high": "181.9300",
            "3. low": "181.6100",
            "4. close": "181.6700",
            "5. volume": "39796"
        },
        "2024-04-19 13:55:00": {
            "1. open": "182.0900",
            "2. high": "182.1700",
            "3. low": "181.7200",
            "4. close": "181.8900",
            "5. volume": "25280"
        },
        "2024-04-19 13:50:00": {
            "1. open": "181.7900",
            "2. high": "182.1100",
            "3. low": "181.7600",
            "4. close": "182.0500",
            "5. volume": "17689"
        },
        "2024-04-19 13:45:00": {
            "1. open": "181.4800",
            "2. high": "181.7600",
            "3. low": "181.4700",
            "4. close": "181.7400",
            "5. volume": "13267"
        },
        "2024-04-19 13:40:00": {
            "1. open": "181.3900",
            "2. high": "181.4600",
            "3. low": "181.3400",
            "4. close": "181.4600",
            "5. volume": "14590"
        },
        "2024-04-19 13:35:00": {
            "1. open": "181.5240",
            "2. high": "181.5400",
            "3. low": "181.3700",
            "4. close": "181.3700",
            "5. volume": "14113"
        },
        "2024-04-19 13:30:00": {
            "1. open": "181.4300",
            "2. high": "181.6600",
            "3. low": "181.4300",
            "4. close": "181.5400",
            "5. volume": "16182"
        },
        "2024-04-19 13:25:00": {
            "1. open": "181.7500",
            "2. high": "181.8050",
            "3. low": "181.4350",
            "4. close": "181.4400",
            "5. volume": "16938"
        },
        "2024-04-19 13:20:00": {
            "1. open": "181.7600",
            "2. high": "181.7900",
            "3. low": "181.6400",
            "4. close": "181.7150",
            "5. volume": "8929"
        },
        "2024-04-19 13:15:00": {
            "1. open": "181.5450",
            "2. high": "181.8000",
            "3. low": "181.4400",
            "4. close": "181.8000",
            "5. volume": "38035"
        },
        "2024-04-19 13:10:00": {
            "1. open": "181.6100",
            "2. high": "181.6700",
            "3. low": "181.5000",
            "4. close": "181.6000",
            "5. volume": "17986"
        },
        "2024-04-19 13:05:00": {
            "1. open": "181.5600",
            "2. high": "181.6000",
            "3. low": "181.4900",
            "4. close": "181.5800",
            "5. volume": "17080"
        },
        "2024-04-19 13:00:00": {
            "1. open": "181.5200",
            "2. high": "181.6650",
            "3. low": "181.4600",
            "4. close": "181.5800",
            "5. volume": "25863"
        },
        "2024-04-19 12:55:00": {
            "1. open": "181.2800",
            "2. high": "181.5650",
            "3. low": "181.2800",
            "4. close": "181.5450",
            "5. volume": "15503"
        },
        "2024-04-19 12:50:00": {
            "1. open": "181.0850",
            "2. high": "181.6000",
            "3. low": "181.0850",
            "4. close": "181.2800",
            "5. volume": "16707"
        },
        "2024-04-19 12:45:00": {
            "1. open": "180.8900",
            "2. high": "181.1100",
            "3. low": "180.8100",
            "4. close": "181.0900",
            "5. volume": "26866"
        },
        "2024-04-19 12:40:00": {
            "1. open": "180.7500",
            "2. high": "181.0300",
            "3. low": "180.7200",
            "4. close": "180.9200",
            "5. volume": "14083"
        },
        "2024-04-19 12:35:00": {
            "1. open": "180.9900",
            "2. high": "181.0400",
            "3. low": "180.6900",
            "4. close": "180.7100",
            "5. volume": "22622"
        },
        "2024-04-19 12:30:00": {
            "1. open": "180.9500",
            "2. high": "181.1360",
            "3. low": "180.8600",
            "4. close": "180.9900",
            "5. volume": "15828"
        },
        "2024-04-19 12:25:00": {
            "1. open": "181.0100",
            "2. high": "181.1400",
            "3. low": "180.9000",
            "4. close": "180.9200",
            "5. volume": "42917"
        },
        "2024-04-19 12:20:00": {
            "1. open": "181.1300",
            "2. high": "181.1800",
            "3. low": "180.9100",
            "4. close": "180.9500",
            "5. volume": "32435"
        },
        "2024-04-19 12:15:00": {
            "1. open": "181.4500",
            "2. high": "181.5300",
            "3. low": "181.1600",
            "4. close": "181.1600",
            "5. volume": "22021"
        },
        "2024-04-19 12:10:00": {
            "1. open": "181.8700",
            "2. high": "181.8700",
            "3. low": "181.4350",
            "4. close": "181.4350",
            "5. volume": "34271"
        },
        "2024-04-19 12:05:00": {
            "1. open": "181.8700",
            "2. high": "181.9310",
            "3. low": "181.6700",
            "4. close": "181.8900",
            "5. volume": "25225"
        },
        "2024-04-19 12:00:00": {
            "1. open": "181.7600",
            "2. high": "181.9800",
            "3. low": "181.7600",
            "4. close": "181.8600",
            "5. volume": "12779"
        },
        "2024-04-19 11:55:00": {
            "1. open": "181.9700",
            "2. high": "181.9700",
            "3. low": "181.7450",
            "4. close": "181.8000",
            "5. volume": "11387"
        },
        "2024-04-19 11:50:00": {
            "1. open": "182.2500",
            "2. high": "182.2900",
            "3. low": "181.9400",
            "4. close": "181.9500",
            "5. volume": "17140"
        },
        "2024-04-19 11:45:00": {
            "1. open": "182.1650",
            "2. high": "182.2400",
            "3. low": "182.1400",
            "4. close": "182.2300",
            "5. volume": "16180"
        },
        "2024-04-19 11:40:00": {
            "1. open": "182.1500",
            "2. high": "182.3000",
            "3. low": "182.0000",
            "4. close": "182.1500",
            "5. volume": "15925"
        },
        "2024-04-19 11:35:00": {
            "1. open": "181.9570",
            "2. high": "182.1500",
            "3. low": "181.8300",
            "4. close": "182.1500",
            "5. volume": "14207"
        },
        "2024-04-19 11:30:00": {
            "1. open": "181.9800",
            "2. high": "182.1500",
            "3. low": "181.9800",
            "4. close": "182.0000",
            "5. volume": "16057"
        },
        "2024-04-19 11:25:00": {
            "1. open": "181.8550",
            "2. high": "182.0100",
            "3. low": "181.8500",
            "4. close": "182.0100",
            "5. volume": "9693"
        },
        "2024-04-19 11:20:00": {
            "1. open": "181.8200",
            "2. high": "181.9500",
            "3. low": "181.7650",
            "4. close": "181.8900",
            "5. volume": "14492"
        },
        "2024-04-19 11:15:00": {
            "1. open": "182.1100",
            "2. high": "182.1500",
            "3. low": "181.7900",
            "4. close": "181.7900",
            "5. volume": "17515"
        },
        "2024-04-19 11:10:00": {
            "1. open": "182.1100",
            "2. high": "182.2200",
            "3. low": "182.0200",
            "4. close": "182.0850",
            "5. volume": "18439"
        },
        "2024-04-19 11:05:00": {
            "1. open": "181.8100",
            "2. high": "182.1300",
            "3. low": "181.7900",
            "4. close": "182.1300",
            "5. volume": "14442"
        },
        "2024-04-19 11:00:00": {
            "1. open": "182.0400",
            "2. high": "182.0700",
            "3. low": "181.8100",
            "4. close": "181.8200",
            "5. volume": "17187"
        },
        "2024-04-19 10:55:00": {
            "1. open": "182.2300",
            "2. high": "182.2400",
            "3. low": "181.9600",
            "4. close": "182.0900",
            "5. volume": "19885"
        },
        "2024-04-19 10:50:00": {
            "1. open": "182.3200",
            "2. high": "182.3900",
            "3. low": "182.1800",
            "4. close": "182.2600",
            "5. volume": "16674"
        },
        "2024-04-19 10:45:00": {
            "1. open": "182.1800",
            "2. high": "182.4300",
            "3. low": "182.1800",
            "4. close": "182.3200",
            "5. volume": "16718"
        },
        "2024-04-19 10:40:00": {
            "1. open": "181.9900",
            "2. high": "182.1900",
            "3. low": "181.9300",
            "4. close": "182.1100",
            "5. volume": "29682"
        },
        "2024-04-19 10:35:00": {
            "1. open": "182.0600",
            "2. high": "182.0700",
            "3. low": "181.8600",
            "4. close": "181.9050",
            "5. volume": "17069"
        },
        "2024-04-19 10:30:00": {
            "1. open": "182.1900",
            "2. high": "182.3600",
            "3. low": "182.0510",
            "4. close": "182.1000",
            "5. volume": "24179"
        },
        "2024-04-19 10:25:00": {
            "1. open": "182.2100",
            "2. high": "182.2300",
            "3. low": "181.9000",
            "4. close": "182.1600",
            "5. volume": "23759"
        },
        "2024-04-19 10:20:00": {
            "1. open": "182.3300",
            "2. high": "182.3700",
            "3. low": "182.1650",
            "4. close": "182.1800",
            "5. volume": "19756"
        },
        "2024-04-19 10:15:00": {
            "1. open": "182.5400",
            "2. high": "182.5980",
            "3. low": "182.3310",
            "4. close": "182.3800",
            "5. volume": "26812"
        },
        "2024-04-19 10:10:00": {
            "1. open": "182.4750",
            "2. high": "182.5400",
            "3. low": "182.3900",
            "4. close": "182.5400",
            "5. volume": "30352"
        },
        "2024-04-19 10:05:00": {
            "1. open": "182.5150",
            "2. high": "182.6800",
            "3. low": "182.4000",
            "4. close": "182.5000",
            "5. volume": "19601"
        },
        "2024-04-19 10:00:00": {
            "1. open": "182.5000",
            "2. high": "182.5100",
            "3. low": "182.3000",
            "4. close": "182.4600",
            "5. volume": "22240"
        }
    }
}